export default "__VITE_ASSET__CG4btxla__"